import i18nFactory from '@yandex-int/i18n';

import { getCSRFToken } from '../../service/ApiHelpers/ApiHelpers';
import { Fetch } from '../../service/Captcha/Captcha';
import { ApiMethodExecutingError } from '../../service/Errors';

import * as keyset from './JavaRestApiMethodExecutor.i18n';

const restI18N = i18nFactory(keyset);

const defaultApiMethodOptions = {
    method: 'POST',
    credentials: 'same-origin',
    mode: 'cors'
};

const defaultHeaders = {
    Accept: 'application/json',
    'Content-Type': 'application/json',
    'X-Requested-With': 'XMLHttpRequest'
};

export class JavaRestApiMethodExecutor {
    private baseUrl: string;
    private fetch: Fetch;
    private token: string = '';

    constructor(baseUrl: string, fetch: Fetch) {
        this.baseUrl = this.normalizeBaseUrl(baseUrl);

        this.fetch = fetch;
    }

    async executeApiMethod<T>(methodPath: string, params: RequestInit): Promise<T> {
        try {
            if (!params.headers) {
                params.headers = { ...defaultHeaders };
            }

            params.headers['X-CSRF-TOKEN'] = this.token;

            const requestUrl = this.getUrl(methodPath);

            const requestParams = Object.assign({}, defaultApiMethodOptions, params);

            const response = await this.fetch(requestUrl, requestParams);

            const body = await response.json();

            // Java ручки требуют csrf токен. Если при первом запросе он не передан -
            // в ответе нам говорят об этом и пишут csrf токен в cookie.
            // В этом случае выполняем запрос еще раз, но уже с токеном.
            if (body.success === false && body.text !== undefined && body.text.includes('csrf')) {
                this.token = getCSRFToken();
                return this.executeApiMethod<T>(methodPath, params);
            } else if (body.success === false && body.code === 54) {
                // обрабатываем ошибку "нет прав", которая приходит с кодом 200
                throw new ApiMethodExecutingError({ message: restI18N('request-error') });
            }

            return body;
        } catch (error) {
            const message = error.name === 'requestError' ? error.message : restI18N('request-error');

            throw new ApiMethodExecutingError({ message });
        }
    }

    private normalizeBaseUrl(baseUrl: string): string {
        return baseUrl.endsWith('/') ? baseUrl : `${baseUrl}/`;
    }

    private normalizeMethodPath(methodPath: string): string {
        return methodPath.startsWith('/') ? methodPath.substr(1) : methodPath;
    }
    private getUrl(methodPath: string): string {
        return `${this.baseUrl}${this.normalizeMethodPath(methodPath)}`;
    }
}
